// Polyfills
// import 'es6-promise/auto'
// import 'babel-polyfill'
// import 'babel-polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import {gerarRouter} from '../router/index'
import {mapaRotasInformacoes} from '../router/index'
import Router from 'vue-router'
import { ColorThemePlugin } from 'vuestic-ui/src/services/ColorThemePlugin'
import store from '../store/index'
import VuesticPlugin from 'vuestic-ui/src/components/vuestic-plugin'
import '../i18n/index'
// import YmapPlugin from 'vue-yandex-maps'
import VueClipboard from 'vue-clipboard2'
import VeeValidate, { Validator } from 'vee-validate'
import * as VueGoogleMaps from 'vue2-google-maps'
import filtros from '@/utils/FiltrosGlobais'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import MetodosGlobais from '@/utils/MetodosGlobais'
import { navigationRoutes } from '@/components/admin/app-sidebar/NavigationRoutes'


store.dispatch('parametrizacao/getRotasPadrao').then(rotasCanonicas => {
  let rotasParsed = rotasCanonicas
  carregarRouter(rotasParsed)
})

function carregarRouter(rotasCanonicas) {
  Vue.use(Router)
  var router = gerarRouter(rotasCanonicas)

  // NOTE: workaround for VeeValidate + vuetable-2
  Vue.use(VeeValidate, { fieldsBagName: 'formFields' })

  Vue.use(VuesticPlugin)
  Vue.use(Sp360Chart)
  Vue.use(Sp360Panel)
  // Vue.use(YmapPlugin)
  Vue.use(VueClipboard)

  Vue.use(ColorThemePlugin, {
    // Add or change theme colors here
    themes: {
      secondary: '#151F23', // @sass/_colors.scss.$black-pearl
    },
  })

  Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyC6JzfGFdB4FNjxHEEr-OnbxhrwsNlyx5Q',
      libraries: 'places,drawing,visualization',
    },
    /// / If you intend to programmatically custom event listener code
    /// / (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    /// / instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    /// / you might need to turn this on.
    // autobindAllEvents: false,
    /// / If you want to manually install components, e.g.
    /// / import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    /// / Vue.component('GmapMarker', GmapMarker)
    /// / then disable the following:
    // installComponents: true,
  })

  // NOTE: workaround for VeeValidate + vuetable-2
  Vue.use(VeeValidate, { fieldsBagName: 'formFields' })
  Validator.localize('pt_BR')

  router.beforeEach(async (to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/auth/login', '/error/connection-error']
    const authRequired = !publicPages.includes(to.path)
    /* Primeiramente, verifica-se o sessionStorage, se não houver nada, assumimos ser
      o Prefeitop para a validação do usuário do videowall. */
    let isIlustrissimo = sessionStorage.getItem('isPrefeito')
    const isPrefeito = isIlustrissimo ? JSON.parse(isIlustrissimo) : true
    let redirect = window.location.href.replace(window.location.origin, '')
    redirect = redirect === '/' || redirect === '/auth/login' || redirect.includes('error') ? '' : redirect
    /* Caso ele não esteja logado e a página requisitada seja privada, validaremos */
    const loggedIn = !MetodosGlobais.isEmpty(store.state.authentication.user) ? store.state.authentication.user : false
    if (authRequired && !loggedIn) {
      let authIP = {}
      /* A primeira requisição sempre entrará aqui */
      if (isPrefeito) {
        try {
          /* Retorna o usuário autenticado OU 401 */
          authIP = await store.dispatch('authentication/prefeito')
        } catch (err) { /* Qualquer erro de conexão, redireciona para página de erro */
          if (![401, 403].includes(err.status)) {
            store.commit('loading/endLoading')
            return next('/error/connection-error')
          }
        }
      } else {
        sessionStorage.setItem('isPrefeito', false)
      }
      /* Se de fato ocorreu um erro de autenticação, redireciona para o login */
      if (authIP == null || authIP == {} || !authIP.status || [401, 403].includes(authIP.status)) {
        sessionStorage.setItem('isPrefeito', false)
        store.commit('loading/forceEndLoading')
        return next({ path: '/auth/login',
          query: {
            error: 'auth.session_expired',
            redirect: redirect,
          } })
      } else {
        let dado = await store.dispatch('parametrizacao/getLocalizacaoPadrao')
        sessionStorage.setItem('localizacao', dado.internacionalizacao)
        Vue.i18n.add('br', JSON.parse(dado.internacionalizacao))
        Vue.i18n.set('br')
      }
    }

    if (authRequired && loggedIn) {
      let localizacao = false
      let parsed = false
      let carregado = Vue.i18n.locale() === 'br'

      if (!carregado) {
        localizacao = sessionStorage.getItem('localizacao')
        try {
          parsed = JSON.parse(localizacao)
        } catch (err) {
          parsed = false
        }
      }

      if (localizacao && parsed || carregado) {
        Vue.i18n.add('br', parsed)
        Vue.i18n.set('br')
        next()
      } else {
        /* Remove qualquer lixo por garantia */
        sessionStorage.removeItem('localizacao')
        try {
          let dado = await store.dispatch('parametrizacao/getLocalizacaoPadrao')
          localizacao = dado.internacionalizacao
          sessionStorage.setItem('localizacao', localizacao)
          Vue.i18n.add('br', JSON.parse(localizacao))
          Vue.i18n.set('br')
          next()
        } catch (err) { /* Qualquer erro de conexão, redireciona para página de erro */
          sessionStorage.removeItem('localizacao')
          if (![401, 403].includes(err.status)) {
            store.commit('loading/forceEndLoading')
            return next('/error/connection-error')
          } else {
            store.commit('loading/forceEndLoading')
            return next({ path: '/auth/login',
              query: {
                error: 'auth.session_expired',
                redirect: redirect,
              } })
          }
        }
      }
    } else {
      next()
    }
  })

  // Vuestic Default
  router.beforeEach((to, from, next) => {
    store.commit('setLoading', true)
    next()
  })

  router.afterEach((to, from) => {
    let registroAcesso = {}
    let user = !MetodosGlobais.isEmpty(store.state.authentication.user) ? store.state.authentication.user : false 
    if(user) {
      registroAcesso.emailUsuario = user.email
      registroAcesso.idUsuario = user.idUsuario
      registroAcesso.rfUsuario = user.username
      registroAcesso.tokenUsuario = user.token
      registroAcesso.nomeUnidade = user.unidade.nome
      registroAcesso.siglaUnidade = user.unidade.sigla
      registroAcesso.idUnidade = user.unidade.id
    }

    if(mapaRotasInformacoes) {
      registroAcesso.tituloOrigem = from.name && mapaRotasInformacoes[from.name] && mapaRotasInformacoes[from.name].displayName ? Vue.i18n.translate(mapaRotasInformacoes[from.name].displayName) : from.name
      registroAcesso.tituloDestino = to.name && mapaRotasInformacoes[to.name] && mapaRotasInformacoes[to.name].displayName ? Vue.i18n.translate(mapaRotasInformacoes[to.name].displayName) : to.name 
      registroAcesso.componenteCaminhoDestino =  to.name && mapaRotasInformacoes[to.name] && mapaRotasInformacoes[to.name].component ? mapaRotasInformacoes[to.name].component : to.name
      registroAcesso.componenteNomeOrigem = from.name && mapaRotasInformacoes[from.name] && mapaRotasInformacoes[from.name].component ? mapaRotasInformacoes[from.name].component.split('/').pop() : from.name
      registroAcesso.componenteNomeDestino = to.name && mapaRotasInformacoes[to.name] && mapaRotasInformacoes[to.name].component ? mapaRotasInformacoes[to.name].component.split('/').pop() : to.name
    }

    registroAcesso.caminhoOrigem = from.path
    registroAcesso.caminhoDestino = to.path
    registroAcesso.nomeOrigem = from.name
    registroAcesso.nomeDestino = to.name
    registroAcesso.dataHora = MetodosGlobais.formataDataHora(new Date())

    store.dispatch('sp360Analytics/contabilizarAcesso', registroAcesso)
    store.commit('setLoading', false)
  })

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
  })
}
